import Vue from 'vue'
import vClickOutside from 'v-click-outside'
import MegaMenu from './desktop/MegaMenu.vue'
import MegaMenuMobile from './mobile/MobileMegaMenu.vue'
import portalData from './portalData.js'

Vue.config.productionTip = false
Vue.use(vClickOutside)


const initVueComponents = menus => {
  const componentProperties = { props: { menus: menus } }

  const items = [
    {
      selector: '#vue-component-mega-menu',
      component: MegaMenu,
    },
    {
      selector: '#vue-global-mega-menu-mobile',
      component: MegaMenuMobile,
    },
  ]

  for (const item of items) {
    if (document.querySelector(item.selector)) {
      new Vue({
        render: h => h(
          item.component,
          componentProperties
        ),
      }).$mount(item.selector)
    } else {
      // 11/13/21 temporarily turning off logs bc it shows up in production - JayL
      //console.log(item.selector + ' Not found')
    }
  }
}


portalData.getMenus().then(menus => { if (menus) initVueComponents(menus) })